// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1MTk0","errorLogs":"EditorFooter_errorLogs__3OADe"};